import { render, staticRenderFns } from "./DomboTitle.vue?vue&type=template&id=cf71f906&scoped=true&"
import script from "./DomboTitle.vue?vue&type=script&lang=js&"
export * from "./DomboTitle.vue?vue&type=script&lang=js&"
import style0 from "./DomboTitle.vue?vue&type=style&index=0&id=cf71f906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf71f906",
  null
  
)

export default component.exports